module.exports = __webpack_public_path__ + "kit_2_header_faded.jpg?55ee8024ac482101737a69e5e8d85358";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kit_2_header_faded.jpg
// module id = 78
// module chunks = 0